import { DropdownItem } from '@/shared/components/form/formFieldDropdownTypes';

export function sanitizeBbchCode(bbchCode: number | string | null | undefined): number | null {
  const parsedValue =
    typeof bbchCode === 'string' ? Number.parseInt(bbchCode, 10) : typeof bbchCode === 'number' ? bbchCode : null;

  if (typeof parsedValue !== 'number' || Number.isNaN(parsedValue)) {
    return null;
  }

  if (parsedValue < 0 || parsedValue > 99) {
    return null;
  }

  return Math.floor(parsedValue);
}

export function formatBbchCode(bbchCode: number): string {
  return String(bbchCode).padStart(2, '0');
}

export function toBbchDropdownItem(bbchCode: number | string | null | undefined): DropdownItem | undefined {
  const sanitizedBbchCode = sanitizeBbchCode(bbchCode);
  if (sanitizedBbchCode === null) {
    return undefined;
  }

  const bbchCodeFormatted = formatBbchCode(sanitizedBbchCode);
  return {
    id: bbchCodeFormatted,
    name: bbchCodeFormatted,
  };
}

export function parseBbchCodeFromDropdownItem(value: DropdownItem | null | undefined): number | null {
  if (!value?.id) {
    return null;
  }

  return sanitizeBbchCode(value.id);
}
